// extracted by mini-css-extract-plugin
export default {"blockContainer":"VS691y1HGmswfpTLRkp6","blockContainerPremium":"etci8eKCBABqG2CralAU","block":"yu7ndwFn9ypsG1AsFqHg"};